import React, { FC, useState, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useHistory } from 'react-router-dom';
import { AuthWrapper } from '@src/components/AuthWrapper';
import { TextField } from '@src/components/TextField';
import { GOOGLE_CAPTCHA_SITE_KEY } from '@src/constants';
import { Button, Appearance } from '@src/components/Button';
import { useAppDispatch } from '@src/redux';
import { useRequestPasswordResetMutation } from '@src/graphql/generated';
import { setErrorFlashMessage } from '@src/redux/actions/flashMessages';
import { trackEvent } from '@src/metrics';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import './styles.scss';

const SUCCESS_MESSAGE = 'Check your email for the password reset link.';

export const ForgetPassword: FC = () => {
  const history = useHistory();

  const [email, setEmail] = useState<string>('');

  const [captcha, setCaptcha] = useState<string | null>('');

  const [successMessage, setSuccessMessage] = useState<string>();

  const dispatch = useAppDispatch();

  const [requestPasswordReset, { loading: isLoading }] = useRequestPasswordResetMutation({
    onCompleted: () => {
      setSuccessMessage(SUCCESS_MESSAGE);
    },
    onError: () => {
      dispatch(setErrorFlashMessage());
    },
  });

  useEffect(() => {
    trackEvent({
      context: MetricContext.FORGET_PASSWORD_PAGE,
      interaction: MetricAction.VIEW_FORGET_PASSWORD_PAGE,
    });
  }, []);

  const isLoginButtonDisabled = !email || !captcha || isLoading;

  const onPasswordResetRequest = () => {
    trackEvent({
      context: MetricContext.FORGET_PASSWORD_PAGE,
      interaction: MetricAction.REQUEST_PASSWORD_RESET,
      payload: { email: email },
    });

    requestPasswordReset({
      variables: {
        requestInput: {
          email: email,
          googleRecaptchaResponse: captcha,
        },
      },
    });
  };

  return (
    <AuthWrapper wrapperClassName="forget-password">
      <div className="forget-password__header-content">
        <h3>Reset your password</h3>
      </div>

      {!successMessage ? (
        <>
          <div>
            <TextField
              defaultValue={email}
              fullWidth={true}
              label="Email"
              onChange={value => setEmail(value.trim())}
              placeholder="Email"
              wrapperClassName="forget-password__input"
            />

            <ReCAPTCHA
              className="forget-password__captcha"
              onChange={value => setCaptcha(value)}
              sitekey={GOOGLE_CAPTCHA_SITE_KEY}
            />
          </div>

          <div className="forget-password__actions">
            <Button appearance={Appearance.SECONDARY} onClick={() => dispatch(history.goBack())}>
              Back
            </Button>

            <Button
              className="forget-password__continue-button"
              isDisabled={isLoginButtonDisabled}
              onClick={onPasswordResetRequest}
            >
              Reset password
            </Button>
          </div>
        </>
      ) : (
        <div>
          <p className="forget-password__success-message fade-in">{successMessage}</p>

          <Button appearance={Appearance.SECONDARY} onClick={() => dispatch(history.goBack())}>
            Back
          </Button>
        </div>
      )}
    </AuthWrapper>
  );
};
